export default __webpack_public_path__ + "static/media/arrow_u_turn.273924bf.svg";